import { render, staticRenderFns } from "./OrderTile.vue?vue&type=template&id=2a7516ee&scoped=true&"
import script from "./OrderTile.vue?vue&type=script&lang=js&"
export * from "./OrderTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7516ee",
  null
  
)

export default component.exports